import { render, staticRenderFns } from "./SubscribersList.vue?vue&type=template&id=ff811886&scoped=true"
import script from "./SubscribersList.vue?vue&type=script&lang=js"
export * from "./SubscribersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff811886",
  null
  
)

export default component.exports